/**
 * Console tracing with a consistent prefix, so app diagnostics can be filtered
 * out of browser console noise with `[uptimer]`.
 */

const PREFIX = '[uptimer]';

function format(scope: string, message: string) {
  return `${PREFIX}[${scope}] ${message}`;
}

export function traceInfo(scope: string, message: string, context?: Record<string, unknown>) {
  if (context) {
    console.info(format(scope, message), context);
  } else {
    console.info(format(scope, message));
  }
}

export function traceError(scope: string, message: string, context?: Record<string, unknown>) {
  if (context) {
    console.error(format(scope, message), context);
  } else {
    console.error(format(scope, message));
  }
}
